import { TransactionReports } from "../../common/transaction-reports/transaction-reports";

export function FrontofficeTransactionReports() {
  return <TransactionReports type="fo" />;
}
